import { Component, DOCUMENT, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ThemeService } from '@marineform/fe-util';
import { filter, take } from 'rxjs';

@Component({
  imports: [IonicModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected title = 'manage';
  readonly #document = inject(DOCUMENT);
  theme = inject(ThemeService);

  constructor() {
    const router = inject(Router);

    router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd ||
            event instanceof NavigationError ||
            event instanceof NavigationCancel,
        ),
        take(1),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.#document.body.classList.add('splash-screen-hidden');
      });
  }
}
